
export const  distanceColor = (val, unit, odo) => {
  const result = {color: 'inherit'};
  if(unit > 0){
    const maintenance = (val + unit) - odo;
    result.maintenance = maintenance;

    if(maintenance < 500)
      result.color = 'error.main';
    else if(maintenance < 1000)
      result.color = 'warning.main';
  }else{
    result.maintenance = val;
  }

  return result;
};
  
export const expiredColor = (val, seconds) => {
  const remider = val - seconds;
  const result = {remider, color: 'inherit'};
  
  if(remider < (86400 * 10))
    result.color = 'error.main';
  else if(remider < (86400 * 20))
    result.color = 'warning.main';

  return result;
}

export const dayColor = (val, seconds) => {
  if(seconds < (val + 86400)){
    return 'error.main';
  }else if(seconds < (val + 2*86400)){
    return 'warning.main';
  }
  return 'primary.main';
}

export const ticketColor = (val) => {
  if (val === null || val === undefined) return 'inherit';
  const colorMap = {
    0: 'warning.main',  // Open
    1: 'primary.main',  // Resolved
    2: 'error.main',    // Rejected
    3: 'text.disabled', // Closed or handled differently
  };
  return colorMap[val] || 'inherit';
}

export const paymentColor = (val) => {
  if (val === null || val === undefined) return 'inherit';
  console.log('=============================', val);
  const colorMap = {
    0: 'warning.main',   // Submitted
    1: 'success.main',   // Paid
    2: 'primary.main',   // Completed
    3: 'text.disabled',  // Closed or handled differently
  };
  return colorMap[val] || 'inherit';
};